import { buildQueryString, ServiceMaker } from ".";

type TGenerateContactUsLeadData = {
  name: {
    fName: string;
    lName: string;
  };
  contact: number;
  message: string;
  subject: string;
  otp: number;
};

export const generateContactUsLead = (data: TGenerateContactUsLeadData) =>
  ServiceMaker("contactUs/create", "POST", data);

export const getContactUsLeads = (params: any) =>
  ServiceMaker(`contactUs/list?${buildQueryString(params)}`, "GET", { params });
